import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const generateLabel = (section, option) =>
  `${option} by ${section === "team" ? "Team member" : "Area"}`;

const ViewSelectorDropdown = ({ viewMode, period, setViewMode, setPeriod }) => {
  const [isOpen, setIsOpen] = useState(false);

  const [label, setLabel] = useState(() => {
    let option = period === 7 ? "Week" : period === 14 ? "2 Weeks" : "Month";
    return generateLabel(viewMode, option);
  });

  const handleSelect = (section, option) => {
    setLabel(generateLabel(section, option));
    setIsOpen(false);

    localStorage.setItem("viewMode", section);
    setViewMode(section);

    let period =
      option === "Week"
        ? 7
        : option === "2 Weeks"
        ? 14
        : option === "Month"
        ? 30
        : null;

    localStorage.setItem("period", period);
    setPeriod(period);
  };

  const dropdownRef = useRef(null);

  const options = {
    area: ["Week", "2 Weeks", "Month"],
    team: ["Week", "2 Weeks", "Month"],
  };

  useEffect(() => {
    if (!isOpen) return;
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen((open) => !open)}
        className="inline-flex items-center justify-between px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none"
      >
        {label}
        <ChevronDown className="ml-2 w-4 h-4" />
      </button>

      {isOpen && (
        <div className="absolute z-20 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg">
          <div className="py-1">
            <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
              View by Area
            </div>
            {options.area.map((item) => (
              <button
                key={item}
                onClick={() => handleSelect("location", item)}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {item}
              </button>
            ))}
          </div>
          <div className="border-t border-gray-200"></div>
          <div className="py-1">
            <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
              View by Team Member
            </div>
            {options.team.map((item) => (
              <button
                key={item}
                onClick={() => handleSelect("team", item)}
                className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                {item}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewSelectorDropdown;
